
export default {
  props: {
    // color: {
    //   type: String,
    // },
    borderType:{
      type: String,
      default: 'noBorder',
    },
    fontSize: {
      type: Number,
      default: 14,
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    marginBottom: {
      type: Number,
      default: 10,
    },
    liWidth: {
      type: Number,
      default: 0,
    },
    liHeight: {
      type: Number,
      default: 28,
    },
    marginRight: {
      type: Number,
      default: 0,
    },
    currTab: {
      type: [Number, String],
      default: 0,
    },
    tabList: {
      type: [Array, Object],
      default: () => {
        return []
      },
    },
    allPrintTab: {
      type: [Array, Object],
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      textColor: 'red',
    }
  },
  computed: {
    comRemaining() {
      const mapTabList = this.tabList.map(i => i.name)
      return this.allPrintTab.filter(element => !mapTabList.includes(element))
    },
  },
  methods: {
    selTab(i) {
      this.$emit('update:currTab', i)
      this.$emit('handle')
    },
  },
}
